module.exports = __webpack_public_path__ + "img/lishubin.dafe8960.jpg";